import React from "react";
import { graphql, Link } from "gatsby";
import Img from "gatsby-image";
import Layout from "../components/layout/Layout";
import { MDXRenderer } from "gatsby-plugin-mdx";
import BoardsSlider from "../components/BoardsSlider";
import SEO from "../components/SEO";
import CaptionedImage from "../components/post-components/CaptionedImage";
import Article from "./../components/layout/Article";

const SinglePost = ({ pageContext: { relatedPosts }, data }) => {
  const {
    body,
    excerpt,
    fields: { slug },
    frontmatter: {
      title,
      date,
      featured_image: { img, link, caption },
      seo,
    },
  } = data.mdx;

  const productsEdges = data.allMarkdownRemark.edges;

  const sliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const breadcrumbs = [
    { title: "Home", path: `/`, active: false },
    { title: "Posts", path: `/blog`, active: false },
    { title, path: `/blog/${slug}`, active: true },
  ];

  return (
    <Layout
      breadcrumbs={breadcrumbs}
      sidebar={{ recentPosts: true, search: true }}
    >
      <SEO
        title={title}
        description={seo && seo.description ? seo.description : excerpt}
      />
      <Article title={title} date={date}>
        {/* <Img className="mb-4" fluid={img.childImageSharp.fluid} /> */}
        <CaptionedImage img={img} caption={caption} link={link} alt={title} />

        <MDXRenderer>{body}</MDXRenderer>
        {relatedPosts && relatedPosts.length > 0 && (
          <div className="mt-6">
            <h3 className="text-lg font-bold">Related Posts</h3>
            <ul className="">
              {(relatedPosts || []).map((post, i) => (
                <li key={i}>
                  <Link
                    to={`/blog/${post.slug}`}
                    className="text-primary hover:text-secondary"
                  >
                    {post.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        )}
        {/* {productsEdges && productsEdges.length > 0 && (
          <div>
            <h5 className="header-h5">Related Boards</h5>
            <BoardsSlider
              edges={data.allMarkdownRemark.edges}
              settings={sliderSettings}
            />
          </div>
        )} */}
      </Article>
    </Layout>
  );
};

export const singlePostQuery = graphql`
  query SinglePostQuery($slug: String!) {
    mdx(fields: { slug: { eq: $slug } }) {
      id
      body
      excerpt(pruneLength: 170)
      frontmatter {
        title
        date(formatString: "MMM DD, YYYY")
        featured_image {
          img {
            childImageSharp {
              fluid(maxWidth: 1000) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          link
          caption{
            html
            text
          }
        }
        # seo {
        #   description
        # }
      }
      fields {
        slug
      }
    }

    allMarkdownRemark {
      edges {
        node {
          id
          frontmatter {
            title
            category
            featured_image {
              img {
                childImageSharp {
                  fluid(maxWidth: 400) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
          fields {
            slug
          }
        }
      }
    }
  }
`;

export default SinglePost;
